import React from 'react';

export default class ModalPDF extends React.Component {
  constructor(props) {
    super();
    this.state = {
    };
  }

	render() {
        const { onShow, handleOpenPDF } = this.props;
        if(onShow !== undefined && !onShow)
            return (null);

        return (
            <div className="modal-block modal-header-color modal-block-success">
                <section className="card">
                    <header className="card-header">
                        <h2 className="card-title">PDF Export</h2>
                    </header>
                    <div className="card-body">
                        <div className="modal-wrapper">
                            <div className="modal-icon">
                                <i className="fas fa-check"></i>
                            </div>
                            <div className="modal-text">
                                <h4>Assessment PDF is ready</h4>
                            </div>
                        </div>
                    </div>
                    <footer className="card-footer">
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <a href={this.props.linkPDF} target="_blank" className="btn btn-success modal-confirm" onClick={() => handleOpenPDF(this)}>Open PDF</a>
                                <button className="btn btn-default modal-dismiss" onClick={this.props.onHide}>Cancel</button>
                            </div>
                        </div>
                    </footer>
                </section>
            </div>
        )
	}
}